import React, { useState } from "react";

const ViewRom = ({ stepData }: any) => {

    return (
        <>
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Range of Motion</h4>
                                </div>
                            </div>
                            <div className="card-body">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Joint Name</th>
                                            <th>Movement Name</th>
                                            <th>Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stepData.rom.map((row: any, index: number) => (
                                            <tr key={index}>
                                                <td>{row.joint_name}</td>
                                                <td>{row.movement_name}</td>
                                                <td>{row.rom_value}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default ViewRom;